import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import '../../../styles/AngelicWhite.css';

const AngelicWhite = ({ isPreview = true }) => {
  const { childName } = useParams();
  const [isRevealed, setIsRevealed] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [rsvpData, setRsvpData] = useState({
    name: '',
    attending: '',
    guests: '1',
    message: ''
  });

  // Parse child name
  const formatName = (name) => {
    if (!name) return 'Baby';
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  };

  const invitationData = {
    childName: formatName(childName),
    baptismDate: 'September 14, 2026',
    baptismDay: 'Sunday',
    baptismTime: '10:00 AM',
    church: 'San Agustin Church',
    churchAddress: 'Intramuros, Manila',
    receptionVenue: 'The Garden Pavilion',
    receptionAddress: '123 Grace Avenue, Makati City',
    receptionTime: '12:00 NN',
    message: 'With hearts full of joy, we invite you to witness and celebrate the baptism of our beloved child.',
    godparents: ['Maria Santos', 'Juan Dela Cruz', 'Ana Reyes', 'Pedro Garcia']
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsRevealed(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="angelic-white">
      {/* Heavenly Elements */}
      <div className="heavenly-elements">
        <div className="cloud cloud-1"></div>
        <div className="cloud cloud-2"></div>
        <div className="cloud cloud-3"></div>
        <div className="sparkle sparkle-1">✦</div>
        <div className="sparkle sparkle-2">✦</div>
        <div className="sparkle sparkle-3">✦</div>
        <div className="dove dove-1">🕊️</div>
        <div className="dove dove-2">🕊️</div>
      </div>

      {/* Main Content */}
      <div className={`angelic-container ${isRevealed ? 'revealed' : ''}`}>
        {/* Navigation */}
        <nav className="angelic-nav">
          <button 
            className={activeSection === 'home' ? 'active' : ''} 
            onClick={() => setActiveSection('home')}
          >
            Home
          </button>
          <button 
            className={activeSection === 'details' ? 'active' : ''} 
            onClick={() => setActiveSection('details')}
          >
            Details
          </button>
          <button 
            className={activeSection === 'rsvp' ? 'active' : ''} 
            onClick={() => setActiveSection('rsvp')}
          >
            RSVP
          </button>
        </nav>

        {/* Home Section */}
        {activeSection === 'home' && (
          <section className="angelic-section home-section">
            <div className="angelic-frame">
              <div className="frame-border">
                <div className="corner-wing top-left">✦</div>
                <div className="corner-wing top-right">✦</div>
                <div className="corner-wing bottom-left">✦</div>
                <div className="corner-wing bottom-right">✦</div>
                
                <div className="home-content">
                  <div className="cross-symbol">✝</div>
                  
                  <p className="invitation-prefix">You are cordially invited to the</p>
                  <h2 className="ceremony-title">Holy Baptism</h2>
                  <p className="of-text">of</p>
                  
                  <div className="child-info">
                    <span className="child-name">{invitationData.childName}</span>
                  </div>

                  <div className="angelic-divider">
                    <span className="divider-wing">🕊️</span>
                  </div>

                  <p className="invitation-message">{invitationData.message}</p>

                  <div className="event-preview">
                    <div className="preview-item">
                      <span className="preview-icon">📅</span>
                      <span className="preview-text">{invitationData.baptismDate}</span>
                    </div>
                    <div className="preview-item">
                      <span className="preview-icon">⛪</span>
                      <span className="preview-text">{invitationData.church}</span>
                    </div>
                  </div>

                  <button 
                    className="angelic-btn"
                    onClick={() => setActiveSection('details')}
                  >
                    View Details
                  </button>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* Details Section */}
        {activeSection === 'details' && (
          <section className="angelic-section details-section">
            <h2 className="section-title">
              <span className="title-wing">✦</span>
              Celebration Details
              <span className="title-wing">✦</span>
            </h2>

            <div className="details-grid">
              <div className="detail-card ceremony-card">
                <div className="card-icon">⛪</div>
                <h3>Holy Ceremony</h3>
                <p className="venue-name">{invitationData.church}</p>
                <p className="venue-address">{invitationData.churchAddress}</p>
                <p className="event-time">{invitationData.baptismTime}</p>
              </div>

              <div className="detail-card reception-card">
                <div className="card-icon">🎉</div>
                <h3>Reception</h3>
                <p className="venue-name">{invitationData.receptionVenue}</p>
                <p className="venue-address">{invitationData.receptionAddress}</p>
                <p className="event-time">{invitationData.receptionTime}</p>
              </div>
            </div>

            <div className="godparents-section">
              <h3>🙏 Godparents</h3>
              <div className="godparents-list">
                {invitationData.godparents.map((godparent, index) => (
                  <span key={index} className="godparent-name">{godparent}</span>
                ))}
              </div>
            </div>

            <div className="dress-code-section">
              <h3>👗 Dress Code</h3>
              <p className="dress-info">White or Pastel Colors</p>
              <p className="dress-note">Semi-Formal Attire</p>
            </div>

            <button 
              className="angelic-btn"
              onClick={() => setActiveSection('rsvp')}
            >
              RSVP Now
            </button>
          </section>
        )}

        {/* RSVP Section */}
        {activeSection === 'rsvp' && (
          <section className="angelic-section rsvp-section">
            <h2 className="section-title">
              <span className="title-wing">✦</span>
              RSVP
              <span className="title-wing">✦</span>
            </h2>

            <form className="angelic-rsvp-form" onSubmit={(e) => e.preventDefault()}>
              <p className="rsvp-intro">We would be blessed by your presence</p>
              <p className="rsvp-deadline">Kindly respond by September 1, 2026</p>

              <div className="form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={rsvpData.name}
                  placeholder="Enter your name"
                  disabled={isPreview}
                />
              </div>

              <div className="form-group">
                <label>Will you be joining us?</label>
                <div className="attendance-options">
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="yes"
                      disabled={isPreview}
                    />
                    <span className="option-icon">🙏</span>
                    <span className="option-text">Joyfully Accepts</span>
                  </label>
                  <label className={`attendance-option ${isPreview ? 'disabled' : ''}`}>
                    <input
                      type="radio"
                      name="attending"
                      value="no"
                      disabled={isPreview}
                    />
                    <span className="option-icon">💔</span>
                    <span className="option-text">Regretfully Declines</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>Number of Guests</label>
                <select
                  name="guests"
                  value={rsvpData.guests}
                  disabled={isPreview}
                >
                  <option value="1">1 Guest</option>
                  <option value="2">2 Guests</option>
                  <option value="3">3 Guests</option>
                  <option value="4">4 Guests</option>
                </select>
              </div>

              <div className="form-group">
                <label>Blessing Message (Optional)</label>
                <textarea
                  name="message"
                  value={rsvpData.message}
                  placeholder="Share your blessings and wishes..."
                  rows="3"
                  disabled={isPreview}
                />
              </div>

              <button type="submit" className="angelic-btn submit-btn" disabled={isPreview}>
                Send RSVP
              </button>
            </form>
          </section>
        )}

        {/* Watermark */}
        <div className="angelic-watermark">
          <a href="/invitations" className="back-to-templates-btn">Back to Designs</a>
          <p>Created with 🙏 by <a href="https://logicatechnology.com" target="_blank" rel="noopener noreferrer">Logica Technology</a></p>
        </div>
      </div>
    </div>
  );
};

export default AngelicWhite;
